/** Bump this version whenever the guidelines or acknowledgment wording changes. */
export const CONDUCT_VERSION = 'conduct-at-church-activities-v1';
export const CONDUCT_ACKNOWLEDGMENT = 'I have reviewed “Conduct at Church Activities” and agree to follow these guidelines.';
export const CONDUCT_ERROR = 'Please review the guidelines and check the box before continuing.';
